import '@mantine/carousel/styles.css';
import '@mantine/charts/styles.css';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import { Notifications } from '@mantine/notifications';
import '@mantine/notifications/styles.css';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import 'survey-analytics/survey.analytics.min.css';
import 'survey-core/survey-core.min.css';
import 'survey-creator-core/survey-creator-core.min.css';
import App from './App';
import './helpers/handlebarsHelpers';
import { stripEmailClickParams } from './helpers/stripEmailClickParams';
import './index.css';
import store from './store/store';
import { theme } from './theme';

// Must run before createRoot — HashRouter reads window.location.hash on first
// render, so the params have to be stripped synchronously before React mounts.
stripEmailClickParams();

// Suppress Recharts ResponsiveContainer warning about negative dimensions
// This is a known issue with Recharts when container dimensions are calculated before DOM is ready
// The charts render correctly, this just suppresses the console noise
// See: https://github.com/recharts/recharts/issues/1686
const originalWarn = console.warn;
console.warn = (...args) => {
  if (args[0]?.includes?.('The width') && args[0]?.includes?.('of chart should be greater than 0')) {
    return;
  }
  originalWarn.apply(console, args);
};

const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <MantineProvider theme={theme}>
      <Notifications position="top-right" />
      <App />
    </MantineProvider>
  </Provider>
);
